import React from 'react';
import { Link } from 'gatsby';
import LazyLoad from 'react-lazyload';

const modelsSquare01 =
  'https://static.clarity.tokyo/images/banners/models_large_02.png';

const SidebarAds = () => (
  <div className="sidebar-wrapper-content">
    <div className="row mx-0 home-right-ads">
      {/* models */}
      <div className="home-right-ads-banner">
        <a href="https://app.clarity.tokyo/">
          <LazyLoad height={226} width={300}>
            <img src={modelsSquare01} alt="" />
          </LazyLoad>
        </a>
      </div>
    </div>
  </div>
);

export default SidebarAds;
